// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel[data-v-53f9bac2] {\n  background: #fff;\n  border-radius: 3px;\n  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.05);\n  border: solid 1px #ececec;\n  padding: 44px 44px;\n  margin-bottom: 48px;\n}\n.warning[data-v-53f9bac2] {\n  font-weight: bold;\n  padding: 1em 0 2em;\n}\n.bottom-buttons[data-v-53f9bac2] {\n  text-align: center;\n}\n.delete-cancel button[data-v-53f9bac2]:first-child {\n  margin-right: 1em;\n}\n", ""]);
// Exports
module.exports = exports;
